/**
 * Frontend mirror of backend expense categories.
 *
 * This is a static copy — the backend is the source of truth. Keep both sides
 * in sync (`backend/app/core/expense_categories.py`). The /expenses/categories
 * endpoint can also be used for dynamic loading, but for selects and labels we
 * want them available synchronously without a network roundtrip.
 */

export const EXPENSE_GROUPS = [
  {
    key: 'buero',
    label: 'Büro & Verwaltung',
    categories: [
      { key: 'bueromiete',           label: 'Büromiete / Home Office Pauschale' },
      { key: 'bueromaterial',        label: 'Büromaterial' },
      { key: 'porto_versand',        label: 'Porto & Versand' },
      { key: 'telefon_internet',     label: 'Telefon & Internet' },
      { key: 'steuerberater',        label: 'Steuerberater' },
      { key: 'rechtsberatung',       label: 'Rechtsberatung' },
      { key: 'buchhaltungssoftware', label: 'Buchhaltungssoftware' },
      { key: 'bankgebuehren',        label: 'Bankgebühren' },
    ],
  },
  {
    key: 'it',
    label: 'IT & Software',
    categories: [
      { key: 'server_hosting',    label: 'Server & Hosting' },
      { key: 'domain_ssl',        label: 'Domain & SSL' },
      { key: 'software_lizenzen', label: 'Software Lizenzen' },
      { key: 'cloud_services',    label: 'Cloud Services' },
      { key: 'api_kosten',        label: 'API-Kosten (Anthropic, Resend)' },
      { key: 'hardware',          label: 'Hardware (Computer, Monitor)' },
      { key: 'smartphone_tablet', label: 'Smartphone & Tablet' },
    ],
  },
  {
    key: 'marketing',
    label: 'Marketing & Vertrieb',
    categories: [
      { key: 'werbung_marketing', label: 'Werbung & Marketing' },
      { key: 'website_kosten',    label: 'Website-Kosten' },
      { key: 'visitenkarten',     label: 'Visitenkarten & Drucksachen' },
      { key: 'messen',            label: 'Messen & Veranstaltungen' },
    ],
  },
  {
    key: 'mobilitaet',
    label: 'Mobilität',
    categories: [
      { key: 'pkw_leasing',      label: 'PKW Leasing' },
      { key: 'kfz_versicherung', label: 'KFZ-Versicherung' },
      { key: 'kfz_steuer',       label: 'KFZ-Steuer' },
      { key: 'benzin',           label: 'Benzin & Kraftstoff' },
      { key: 'werkstatt',        label: 'Werkstatt & Reparatur' },
      { key: 'parkgebuehren',    label: 'Parkgebühren' },
      { key: 'oepnv',            label: 'Öffentliche Verkehrsmittel' },
      { key: 'taxi_mietwagen',   label: 'Taxi & Mietwagen' },
      { key: 'reisekosten',      label: 'Reisekosten' },
    ],
  },
  {
    key: 'versicherungen',
    label: 'Versicherungen',
    categories: [
      { key: 'betriebshaftpflicht', label: 'Betriebshaftpflicht' },
      { key: 'berufsunfaehigkeit',  label: 'Berufsunfähigkeit' },
      { key: 'krankenversicherung', label: 'Krankenversicherung' },
      { key: 'rechtsschutz',        label: 'Rechtsschutzversicherung' },
    ],
  },
  {
    key: 'weiterbildung',
    label: 'Personal & Weiterbildung',
    categories: [
      { key: 'fortbildung',      label: 'Fortbildung & Kurse' },
      { key: 'fachliteratur',    label: 'Fachliteratur & Bücher' },
      { key: 'konferenzen',      label: 'Konferenzen & Seminare' },
      { key: 'mitgliedschaften', label: 'Mitgliedschaften' },
    ],
  },
  {
    key: 'sonstiges',
    label: 'Sonstiges',
    categories: [
      { key: 'bewirtung', label: 'Bewirtung (Geschäftsessen)' },
      { key: 'geschenke', label: 'Geschenke (Kunden)' },
      { key: 'sonstige',  label: 'Sonstige Betriebsausgaben' },
    ],
  },
];

export const PAYMENT_METHODS = [
  { key: 'ueberweisung', label: 'Überweisung' },
  { key: 'karte',        label: 'Karte' },
  { key: 'bar',          label: 'Bar' },
  { key: 'lastschrift',  label: 'Lastschrift' },
];

const CATEGORY_LOOKUP = {};
EXPENSE_GROUPS.forEach((g) => {
  g.categories.forEach((c) => {
    CATEGORY_LOOKUP[c.key] = { ...c, group_key: g.key, group_label: g.label };
  });
});

const PAYMENT_LOOKUP = PAYMENT_METHODS.reduce((acc, pm) => {
  acc[pm.key] = pm.label;
  return acc;
}, {});

export const categoryLabel = (key) =>
  (CATEGORY_LOOKUP[key] && CATEGORY_LOOKUP[key].label) || key || '—';

export const categoryGroup = (key) =>
  (CATEGORY_LOOKUP[key] && CATEGORY_LOOKUP[key].group_label) || '—';

export const paymentMethodLabel = (key) => PAYMENT_LOOKUP[key] || key || '—';
